import type { Option } from '../../types.ts';
import { PaginationDefaultValue } from './types.ts';

export const paginationDefaultValues = {
  [PaginationDefaultValue.XS]: 5,
  [PaginationDefaultValue.SM]: 10,
  [PaginationDefaultValue.MD]: 100,
  [PaginationDefaultValue.LG]: 250,
  [PaginationDefaultValue.XL]: 500,
};

export const paginationPresetReduced: Option<number>[] = [
  { label: paginationDefaultValues[PaginationDefaultValue.XS].toString(), value: paginationDefaultValues[PaginationDefaultValue.XS] },
  { label: paginationDefaultValues[PaginationDefaultValue.SM].toString(), value: paginationDefaultValues[PaginationDefaultValue.SM] },
  { label: '25', value: 25 },
];

export const paginationPresetDefault: Option<number>[] = [
  { label: paginationDefaultValues[PaginationDefaultValue.MD].toString(), value: paginationDefaultValues[PaginationDefaultValue.MD] },
  { label: paginationDefaultValues[PaginationDefaultValue.LG].toString(), value: paginationDefaultValues[PaginationDefaultValue.LG] },
  { label: paginationDefaultValues[PaginationDefaultValue.XL].toString(), value: paginationDefaultValues[PaginationDefaultValue.XL] },
];
